import React, { useState, useEffect } from 'react';
import { MessageSquare, Info, X } from 'lucide-react';

interface CheckoutAssistantProps {
  step: number;
}

const TIPS: Record<number, string> = {
  1: 'A frota é ajustada em blocos de 5 veículos. Cada bloco adicional custa R$12,90/mês no PRO e R$19,90/mês no Avançado. Você pode expandir a qualquer momento!',
  2: 'O LocaSmartCheck complementa seu plano com vistorias profissionais. Assista ao vídeo para conhecer!',
  3: 'Seus dados de pagamento são protegidos com criptografia de ponta a ponta.',
};

const CheckoutAssistant: React.FC<CheckoutAssistantProps> = ({ step }) => {
  const [isOpen, setIsOpen] = useState(true);
  const tip = TIPS[step];

  useEffect(() => {
    setIsOpen(true);
  }, [step]);

  if (!tip) return null;

  return (
    <div className="fixed bottom-6 right-6 flex flex-col items-end gap-3 z-50">
      {isOpen && (
        <div
          className="bg-white border border-[#e2e8f0] rounded-[14px_14px_4px_14px] p-[18px_20px] max-w-[280px] relative"
          style={{
            boxShadow: '0 8px 32px rgba(0,0,0,0.10), 0 2px 8px rgba(0,0,0,0.06)',
            animation: 'slideUp 0.4s ease-out',
          }}
        >
          <button
            onClick={() => setIsOpen(false)}
            className="absolute top-2 right-[10px] text-[#94a3b8] hover:text-[#64748b] bg-transparent border-none cursor-pointer p-0.5 leading-none text-base"
          >
            <X size={14} />
          </button>
          <div className="flex items-center gap-1.5 mb-2">
            <Info size={14} className="text-[#1F467E]" />
            <span className="text-[11px] uppercase tracking-[0.8px] text-[#1F467E] font-bold">
              Dica
            </span>
          </div>
          <p className="text-[13px] text-[#475569] leading-relaxed m-0">{tip}</p>
        </div>
      )}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-12 h-12 bg-[#1F467E] rounded-full flex items-center justify-center cursor-pointer border-none hover:scale-105 transition-transform"
        style={{ boxShadow: '0 4px 16px rgba(31,70,126,0.3)' }}
      >
        <MessageSquare size={22} className="text-white" />
      </button>
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default CheckoutAssistant;
